export default {
  components: {},
  options: {},
  styles: [() => import("./index.scss")],
  externalCss: [],
};
